<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="Agenda de Mantenimiento">
        <MaintenanceCalendarP />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MaintenanceCalendarP from "@/views/apps/calendar/CalendarMaintenanceNotBreadcrumb";
export default {
  components: {
    MaintenanceCalendarP
  }
};
</script>

<style></style>
